import {Box} from '@chakra-ui/react'
import Header from './Header'
import LoadingScreen from './LoadingScreen'
import {useEffect, useState} from 'react'
import Situation from './Situation'
import Exercise1 from './Exercise1'
import Exercise2 from './Exercise2'
import Exercise3 from './Exercise3'
import reviseRequest from '@apis/revise'
import {useDispatch, useSelector} from 'react-redux'
import {updateAudioUrl, updateCurrentQuestion} from '@redux/revise/revise'
import {useNavigate} from 'react-router-dom'
import './index.css'
import FormReportError from '@components/FormReportError'
import {FEATURE_REPORT_ERROR, SCREEN_REPORT_ERROR} from '@utils/Const'

const ReviseRoom = () => {
  const {currentQuestion} = useSelector((state: any) => state.revise)
  const [isLoadingProgress, setIsLoadingProgress] = useState<any>(true)
  const [dataQuestions, setDataQuestions] = useState<any>()
  const [currentLevelIndex, setCurrentLevelIndex] = useState<any>(0)
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<any>(0)
  const [screenReportError, setScreenReportError] = useState<any>('')
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    getQuestions()
  }, [])

  useEffect(() => {
    if (!dataQuestions || !dataQuestions?.questions) {
      return
    }
    dispatch(
      updateCurrentQuestion(
        dataQuestions?.questions[currentLevelIndex][currentQuestionIndex],
      ),
    )
  }, [dataQuestions, currentLevelIndex, currentQuestionIndex])

  useEffect(() => {
    if (
      !currentQuestion ||
      currentQuestion.type === 'LV2_LISTEN_CONVERSATION'
    ) {
      return
    }
    //Kiểm tra nếu đã học hết các câu
    if (currentLevelIndex === 2) {
      //Gửi data các câu đã học cuối level
      const params = {
        phrase_package_id: dataQuestions?.phrase_package_id,
        phrase_question_ids: dataQuestions?.basic_phrase_question_ids,
        phrase_bucket_ids: dataQuestions?.phrase_bucket_ids,
      }
      reviseRequest.sendQuestionHistories(params)
    }
  }, [currentLevelIndex])

  useEffect(() => {
    console.log(currentQuestion)
    console.log({dataQuestions})
    switch (currentQuestion?.type) {
      case 'LV1_LISTEN_AND_CHOOSE':
        setScreenReportError(SCREEN_REPORT_ERROR.ON_CO_BAN_TRAC_NGHIEM)
        break
      case 'LV1_SPEAKING':
        setScreenReportError(SCREEN_REPORT_ERROR.ON_CO_BAN_GHI_AM)
        break
      case 'LV2_LISTEN_CONVERSATION':
        setScreenReportError(SCREEN_REPORT_ERROR.XEM_TINH_HUONG)
        break
      case 'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT':
        setScreenReportError(SCREEN_REPORT_ERROR.NGHE_DICH)
        break
      case 'LV3_LISTEN_AND_ANSWER_BY_TYPING':
        setScreenReportError(SCREEN_REPORT_ERROR.NGHE_TRA_LOI_DIEN_TU)
        break
      case 'LV3_LISTEN_AND_ANSWER_BY_SPEAKING':
        setScreenReportError(SCREEN_REPORT_ERROR.NGHE_TRA_LOI_GHI_AM)
        break
      default:
        setScreenReportError(SCREEN_REPORT_ERROR.ON_CO_BAN_TRAC_NGHIEM)
        break
    }
  }, [currentQuestion])

  const getQuestions = async () => {
    const res = await reviseRequest.getQuestions()
    if (res?.status === 200) {
      setDataQuestions(res.data.data)
      dispatch(updateAudioUrl(res.data.data?.questions[1][0]?.data.audio))
    }
  }

  if (!isLoadingProgress && !currentQuestion) {
    navigate('/learn/revise')
  }

  return (
    <Box minH={'100vh'} bg={'#F0F6FD'}>
      {isLoadingProgress ? (
        <LoadingScreen
          setIsLoadingProgress={setIsLoadingProgress}
          dataQuestions={dataQuestions}
        />
      ) : (
        <>
          <Header
            dataQuestions={dataQuestions}
            currentLevelIndex={currentLevelIndex}
            currentQuestionIndex={currentQuestionIndex}
            setCurrentLevelIndex={setCurrentLevelIndex}
            setCurrentQuestionIndex={setCurrentQuestionIndex}
          />

          {/* nghe và chọn cụm để điền */}
          {currentQuestion?.type === 'LV1_LISTEN_AND_CHOOSE' && <Exercise1 />}

          {/* nói cụm từ */}
          {currentQuestion?.type === 'LV1_SPEAKING' && <Exercise2 />}

          {/* Phần xem tình huống */}
          {(currentQuestion?.type === 'LV2_LISTEN_CONVERSATION' ||
            currentQuestion?.type ===
              'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT') && <Situation />}

          {/* level 2 và 3 */}
          {(currentLevelIndex === 1 || currentLevelIndex === 2) &&
            currentQuestion.type !== 'LV2_LISTEN_CONVERSATION' &&
            currentQuestion.type !==
              'LV3_LISTEN_CONVERSATION_WITH_TRANSCRIPT' && (
              <Exercise3
                dataQuestions={dataQuestions}
                currentLevelIndex={currentLevelIndex}
                currentQuestionIndex={currentQuestionIndex}
                setCurrentLevelIndex={setCurrentLevelIndex}
                setCurrentQuestionIndex={setCurrentQuestionIndex}
              />
            )}
        </>
      )}
      <FormReportError
        feature={FEATURE_REPORT_ERROR.PRACTICE_PHRASE}
        screen={screenReportError}
      />
    </Box>
  )
}

export default ReviseRoom
